import React from "react";
import { Box, Typography } from "@material-ui/core";
import useStyles from "./PaymentForm.styles";
import { SummaryPackage } from "../../checkoutPage/components/Summary/SummaryPackage";
import { SummaryPayments } from "../../checkoutPage/components/Summary/SummaryPayments";

interface PaymentSummaryProps {
  quoteId: string;
}

const PaymentSummary: React.FC<PaymentSummaryProps> = () => {
  const classes = useStyles();

  return (
    <Box className={`${classes.paymentPageSection} ${classes.root}`}>
      <Box px={4} pt={4}>
        <Typography variant="h2" color="primary" gutterBottom>
          Summary
        </Typography>
      </Box>
      <SummaryPackage />
      <SummaryPayments />
    </Box>
  );
};

export default PaymentSummary;
